import React from 'react';
import { Card, Divider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { headerSx, rootSx, titleSx } from '../styles';
import {
  cardSx,
  infoRowSx,
  labelSx,
  valueSx,
  dividerSx,
  totalLabelSx,
  totalValueSx,
} from './styles';

interface ConfirmationStepProps {
  amount: number;
  method: string;
  account: string;
  receiveAmount: number;
}

const ConfirmationStep: React.FC<ConfirmationStepProps> = ({
  amount,
  method,
  account,
  receiveAmount,
}) => {
  const { t } = useTranslation('withdraw');

  return (
    <Stack sx={rootSx}>
      <Stack sx={headerSx}>
        <Typography sx={titleSx}>{t('CONFIRMATION.TITLE')}</Typography>
      </Stack>

      <Card sx={cardSx}>
        <Stack sx={infoRowSx}>
          <Typography sx={labelSx}>{t('CONFIRMATION.AMOUNT')}</Typography>
          <Typography sx={valueSx}>{amount}€</Typography>
        </Stack>

        <Stack sx={infoRowSx}>
          <Typography sx={labelSx}>{t('CONFIRMATION.METHOD')}</Typography>
          <Typography sx={valueSx}>{method}</Typography>
        </Stack>

        <Stack sx={infoRowSx}>
          <Typography sx={labelSx}>{t('CONFIRMATION.ACCOUNT')}</Typography>
          <Typography sx={valueSx}>{account}</Typography>
        </Stack>

        <Divider sx={dividerSx} />

        <Stack sx={infoRowSx}>
          <Typography sx={totalLabelSx}>{t('CONFIRMATION.YOU_WILL_RECEIVE')}</Typography>
          <Typography sx={totalValueSx}>{receiveAmount}€</Typography>
        </Stack>
      </Card>
    </Stack>
  );
};

export default ConfirmationStep;